import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class Page extends Component {
    static propTypes = {
        className: PropTypes.string
    }
    static defaultProps = {
        className: ""
    }
    render() {
        return <div className={"content-page " + this.props.className}>
            {this.props.children}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Layout/Page.jsx